import {
  call,
  put,
  takeEvery,
  takeLeading,
  all,
  select,
} from 'redux-saga/effects';
import API from 'constants/api';
import { getData } from 'util/Api';
import { actions } from './slice';
import { logisticOperatorsItemsSelector } from './selectors';

function* fetchSaga() {
  try {
    const logisticOperators = yield call(getData, API.logisticOperator.getAll);
    yield put({ type: actions.success.type, payload: logisticOperators });
  } catch (error) {
    yield put({ type: actions.failure.type });
  }
}

function* initialSaga() {
  const logisticOperators = yield select(logisticOperatorsItemsSelector);
  if (logisticOperators.length !== 0) return;
  yield put({ type: actions.fetch.type });
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.initial, initialSaga),
    takeLeading(actions.fetch, fetchSaga),
  ]);
}
